import React from "react";
import { Button, Col } from "reactstrap";
import illustration from "assets/img/illustration.png";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 3rem;
`;

const NoAccessLabel = styled.h1`
  color: #00316d;
  font-weight: bold;
  font-size: 80px;
  display: flex;
  justify-content: center;
  margin: 0;
  align-items: center;
`;

const NoAccessDesc = styled.p`
  font-size: 18px;
  color: #000000;
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 0;
  align-items: center;
`;

const NoAccessIcon = styled.img`
  width: 40%;
  margin-bottom: 20px;
`;

const NoAccessButton = styled(Button)`
  background: #00316d;
  box-shadow: 0px 2px 7px rgba(43, 53, 133, 0.27);
  border-radius: 11px;
  height: 45px;
  padding: 10px 20px;
  font-weight: bold;

  &:hover {
    background-color: #00316d;
  }
`;

const ButtonSection = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
  align-items: center;
`;

const NoAccessIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NoAccessDescSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  flex-direction: column;
`;

const Container = styled.div`
  margin-right: 8rem;
  margin-left: 8rem;

  @media (max-width: 768px) {
    margin-right: 3rem;
    margin-left: 3rem;
  }

  @media (max-width: 575.98px) {
    margin-right: 2rem;
    margin-left: 2rem;
  }
`;

const NotFound = () => {
  return (
    <Container>
      <Wrapper>
        <Col lg="12">
          <NoAccessIconWrapper>
            <NoAccessIcon
              src={illustration}
              alt="404 illustration"
            />
          </NoAccessIconWrapper>

          <NoAccessDescSection>
            <NoAccessLabel>{"404"}</NoAccessLabel>
            <NoAccessDesc>
              {"Uh oh! The page you are looking for couldn’t be found\r"}
            </NoAccessDesc>
          </NoAccessDescSection>

          <ButtonSection>
            <NoAccessButton href="/">{"Go to Home"}</NoAccessButton>
          </ButtonSection>
        </Col>
      </Wrapper>
    </Container>
  );
};

export default NotFound;
